import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const invoices = createReducer({}, (builder) => {
  builder.addCase(actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS, (state, action) => {
    const { response = {} } = action;
    const { entities = {} } = response;
    const { invoices = {} } = entities;
    return { ...state, ...invoices };
  });
});

export default invoices;
